import { orderTypes } from './orderTypes'

const INITIAL_STATE = {
    allOrders: [],
    order: {},
    orderProcess: [],
    allOrdersToPrint: [],
    orderLoading: false,
    orderMeta: {},
    crudLoading: false,
    processMeta: {},
    processLoading: false,
    deleteLoading: false,
    updatedProcessID: 0,
    loading: false,
}

const ordersReducer = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        //   ------------
        case orderTypes.GET_ALL_ORDERS_START:
            return {
                // ...state,
                allOrders: [],
                orderProcess: [],
                orderLoading: true,
            }
        case orderTypes.GET_ALL_ORDERS_SUCCESS:
            return {
                ...state,
                allOrders: actions.payload,
                allOrdersToPrint: actions.allOrdersToPrint,
                orderMeta: actions.meta,
            }
        case orderTypes.GET_ALL_ORDERS_END:
            return {
                ...state,
                orderLoading: false,
            }
        case orderTypes.GET_ALL_ORDERS_FAILED:
            return {
                ...state,
                orderLoading: false,
            }

        case orderTypes.ADD_NEW_ORDER_BY_ADMIN_START:
            return {
                allOrders: [],
                orderLoading: true,
                crudLoading: true,
            }
        case orderTypes.ADD_NEW_ORDER_BY_ADMIN_SUCCESS:
            return {
                ...state,
                allOrders: actions.payload,
            }
        case orderTypes.ADD_NEW_ORDER_BY_ADMIN_END:
            return {
                ...state,
                crudLoading: false,
            }
        case orderTypes.ADD_NEW_ORDER_BY_ADMIN_FAILED:
            return {
                ...state,
                crudLoading: false,
            }

        //  ----------------- process --------------
        //get a process of order

        case orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_START:
            return {
                ...state,
                loading: true,
            }
        case orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_SUCCESS:
            return {
                ...state,
                orderProcess: actions.payload,
            }
        case orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_FAILED:
            return {
                ...state,
                loading: false,
            }
        case orderTypes.GET_A_ORDER_PROCESS_BY_ADMIN_END:
            return {
                ...state,
                loading: false,
            }
        // --------------- update process
        case orderTypes.UPDATE_PROCESS_BY_ADMIN_START:
            return {
                ...state,
                crudProcessLoading: true,
                updatedProcessID: actions.updatedID,
            }
        case orderTypes.UPDATE_PROCESS_BY_ADMIN_SUCCESS:
            return {
                ...state,
                orderProcess: actions.payload,
                updatedProcessID: actions.updatedID,
            }
        case orderTypes.UPDATE_PROCESS_BY_ADMIN_FAILED:
            return {
                ...state,
                crudProcessLoading: false,
            }
        case orderTypes.UPDATE_PROCESS_BY_ADMIN_END:
            return {
                ...state,
                crudProcessLoading: false,
            }

        // --------------- create process
        case orderTypes.ADD_NEW_PROCESS_BY_ADMIN_START:
            return {
                ...state,
                crudProcessLoading: true,
            }
        case orderTypes.ADD_NEW_PROCESS_BY_ADMIN_SUCCESS:
            return {
                ...state,
                orderProcess: actions.payload,
            }
        case orderTypes.ADD_NEW_PROCESS_BY_ADMIN_FAILED:
            return {
                ...state,
                crudProcessLoading: false,
            }
        case orderTypes.ADD_NEW_PROCESS_BY_ADMIN_END:
            return {
                ...state,
                crudProcessLoading: false,
            }

        // --------------- delete process
        case orderTypes.DELETE_A_PROCESS_START:
            return {
                ...state,
                deleteLoading: true,
            }
        case orderTypes.DELETE_A_PROCESS_SUCCESS:
            return {
                ...state,
                orderProcess: actions.payload,
            }
        case orderTypes.DELETE_A_PROCESS_FAILED:
            return {
                ...state,
                deleteLoading: false,
            }
        case orderTypes.DELETE_A_PROCESS_END:
            return {
                ...state,
                deleteLoading: false,
            }

        // --------------- DELETE A ORDER BY ADMIN
        case orderTypes.DELETE_A_ORDER_BY_ADMIN_START:
            return {
                allOrders: [],
                orderLoading: true,
                crudLoading: false,
            }
        case orderTypes.DELETE_A_ORDER_BY_ADMIN_SUCCESS:
            return {
                ...state,
                allOrders: actions.payload,
            }
        case orderTypes.DELETE_A_ORDER_BY_ADMIN_FAILED:
            return {
                ...state,
                allOrders: actions.payload,
                crudLoading: false,
            }
        case orderTypes.DELETE_A_ORDER_BY_ADMIN_END:
            return {
                ...state,
                crudLoading: false,
            }

        // get a order By admin
        case orderTypes.GET_A_ORDER_BY_ADMIN_START:
            return {
                ...state,
                order: {},
                loading: true,
            }
        case orderTypes.GET_A_ORDER_BY_ADMIN_SUCCESS:
            return {
                ...state,
                loading: false,
                order: actions.payload,
            }
        case orderTypes.GET_A_ORDER_BY_ADMIN_FAILED:
            return {
                ...state,
                order: {},
                loading: false,
            }
        case orderTypes.GET_A_ORDER_BY_ADMIN_END:
            return {
                ...state,
                loading: false,
            }

        default:
            return state
    }
}

export default ordersReducer
